<section class="container">
    @if (users) {
        <app-user-info [users]="users"></app-user-info>
    }
</section>
